import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { ChatPane, useChatThread } from "@/chat";
import { requestConversationTitle, useUnreadConversations } from "@/hooks/useCloudChat";

function ConversationPage() {
  const { conversationId } = Route.useParams();

  // Mark this conversation as viewed so its unread (orange) dot clears.
  useEffect(() => {
    useUnreadConversations.getState().setViewing(conversationId);
    return () => useUnreadConversations.getState().setViewing(null);
  }, [conversationId]);

  // Generate the sidebar title the moment the first run finishes (streaming → ready). This is
  // the reliable trigger; the Recents poll's completion detection is the fallback. (The title
  // itself only shows in the sidebar — the chat view has no title header.)
  const { status } = useChatThread(conversationId);
  const prevStatus = useRef(status);
  useEffect(() => {
    if (prevStatus.current === "streaming" && status === "ready") {
      requestConversationTitle(conversationId);
    }
    prevStatus.current = status;
  }, [status, conversationId]);

  return (
    <div className="relative h-full">
      <ChatPane conversationId={conversationId} placeholder="Ask anything" defaultDeepResearch />
    </div>
  );
}

export const Route = createFileRoute("/_auth/_agents/chats/$conversationId")({
  component: ConversationPage,
});
